import { useEffect, useState } from 'react'
import { Box, Button, Container, Paper, TextField, Typography } from '@mui/material'
import { createQuiz, getQuiz, updateQuiz } from '../services/Common/quiz.service'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function QuizFormPage(){
  const { id } = useParams()
  const navigate = useNavigate()
  const [form, setForm] = useState({ question:'', choices:['','','',''], correctIndex:0, status:'draft', targetRole:'general' })

  useEffect(() => {
    if (id) (async ()=>{
      try{
        const data = await getQuiz(id);
        setForm({
          ...data,
          choices: (data.choices || []).map(c => typeof c === 'string' ? c : (c?.text || ''))
        });
      }catch(e){console.error(e);toast.error('Failed to load')}
    })()
  }, [id])

  const onChangeChoice = (idx, val) => {
    const c = [...form.choices]
    c[idx] = val
    setForm({...form, choices: c})
  }

  const onSave = async () => {
    try {
      if (id) await updateQuiz(id, form)
      else await createQuiz(form)
      toast.success('Saved')
      navigate('/quiz')
    } catch (e){ console.error(e); toast.error('Save failed') }
  }

  return (
    <Container>
      <Box my={2}>
        <Typography variant='h4'>{id ? 'Edit Quiz' : 'Create Quiz'}</Typography>
      </Box>
      <Paper sx={{p:2}}>
        <TextField fullWidth label='Question' value={form.question} onChange={e=>setForm({...form, question: e.target.value})} />
        {form.choices.map((c, idx)=> (
          <TextField key={idx} fullWidth sx={{mt:2}} label={`Choice ${idx+1}`} value={c} onChange={e=>onChangeChoice(idx, e.target.value)} />
        ))}
        <TextField fullWidth sx={{mt:2}} label='Correct Index (0-3)' value={form.correctIndex} onChange={e=>setForm({...form, correctIndex: Number(e.target.value)})} />
        <TextField
          select
          SelectProps={{ native: true }}
          fullWidth
          sx={{mt:2}}
          label='Question For'
          value={form.targetRole || 'general'}
          onChange={e=>setForm({...form, targetRole: e.target.value})}
        >
          <option value='general'>General (All Players)</option>
          <option value='casual_gamer'>Casual Gamer</option>
          <option value='content_creator'>Content Creator</option>
          <option value='esports_player'>Esports Player</option>
        </TextField>
        <TextField
          select
          SelectProps={{ native: true }}
          fullWidth
          sx={{mt:2}}
          label='Status'
          value={form.status || 'draft'}
          onChange={e=>setForm({...form, status: e.target.value})}
        >
          <option value='draft'>Draft</option>
          <option value='published'>Published</option>
          <option value='archived'>Archived</option>
        </TextField>
        <Box mt={2}>
          <Button variant='contained' onClick={onSave}>Save</Button>
        </Box>
      </Paper>
    </Container>
  )
}
